import { PageId } from 'constants/pages'

export const enum PageIdWoofzRfnd3Nd {
  SEX_RFND3_ND = PageId.SEX_RFND3_ND,
  DOG_AGE_RFND3_ND = PageId.DOG_AGE_RFND3_ND,
  DOG_BREED_RFND3_ND = PageId.DOG_BREED_RFND3_ND,
  URGE_RFND3_ND = PageId.URGE_RFND3_ND,
  COMMANDS_61_RFND3_ND = PageId.COMMANDS_61_RFND3_ND,
  COMMANDS_62_RFND3_ND = PageId.COMMANDS_62_RFND3_ND,
  COMMANDS_63_RFND3_ND = PageId.COMMANDS_63_RFND3_ND,
  URGE_RFND3_2_ND = PageId.URGE_RFND3_2_ND,
  POTTY_RFND3_ND = PageId.POTTY_RFND3_ND,
  BEHAVIOR_RFND3_ND = PageId.BEHAVIOR_RFND3_ND,
  TRAINING_RFND3_ND = PageId.TRAINING_RFND3_ND,
  PREPARE_FLOW_RFND3_ND = PageId.PREPARE_FLOW_RFND3_ND,
  DOG_STATISTICS_RFND3_ND = PageId.DOG_STATISTICS_RFND3_ND,
  EMAIL_RFND3_ND = PageId.EMAIL_RFND3_ND,
  NEWSLETTER_URGE_RFND3_ND = PageId.NEWSLETTER_URGE_RFND3_ND,
  LAST_CHANCE_OFFER_RFND3_ND = PageId.LAST_CHANCE_OFFER_RFND3_ND,
  SUBSCRIPTIONS_RFND3_ND = PageId.SUBSCRIPTIONS_RFND3_ND,
  CANCEL_OFFER_RFND3_ND = PageId.CANCEL_OFFER_RFND3_ND,
  CHAT_UPSELL_RFND3_ND = PageId.CHAT_UPSELL_RFND3_ND,
  UPSELL_RFND3_ND = PageId.UPSELL_RFND3_ND,
  DOWNLOAD_RFND3_ND = PageId.DOWNLOAD_RFND3_ND,
  ACCOUNT_NOVE8 = PageId.ACCOUNT_NOVE8,
}
